import styled from '@emotion/styled';
import { getRecipeColor, Stack, Modal, ColorVariant } from '@ui-components/neo.tax';

export const StyledStack = styled(Stack)({ height: 20, overflow: 'hidden' });

export const StyledGauge = styled(Stack)({}, ({ percent }: { percent: number }) => ({
  width: `${percent}%`,
  backgroundColor: getRecipeColor(ColorVariant.PRIMARY, 'whiteBg').text,
}));

export const StyledModal = styled(Modal)({
  width: 515,
});
